import PcModelComponentImageModal from 'containers/PcModel/PcModelComponentImageModal';
import PropTypes from 'prop-types';
import { useState } from 'react';
import PcModelOptionImage from '../PcModelOptionImage';
import styles from './styles';

const PcModelOptionImageWithModal = ({
  src,
  alt,
  width,
  height,
  groupTitle,
  options,
  currentOption,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="trigger" onClick={() => setIsModalOpen(true)}>
        <PcModelOptionImage src={src} alt={alt} width={width} height={height} />
      </div>

      <PcModelComponentImageModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        groupTitle={groupTitle}
        options={options}
        currentOption={currentOption}
      />
      <style jsx>{styles}</style>
    </>
  );
};

PcModelOptionImageWithModal.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  groupInfo: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  currentOption: PropTypes.object.isRequired,
};

PcModelOptionImageWithModal.defaultProps = {
  src: '/images/image-placeholder.png',
  alt: 'Component Image',
  height: 300,
  width: 300
};

export default PcModelOptionImageWithModal;
